import { GeoJsonProperties } from 'geojson'
import { ReactElement } from 'react'
import Supercluster, { ClusterProperties } from 'supercluster'

import { FeaturesClusterMarker } from '../FeaturesClusterMarker'
import { FeatureMarker } from '../FeatureMarker'
import { useSupercluster } from 'features/RoutesPlanning/hooks'
import { IDatasetLocationProps, TDatasetLocationsGeojson } from 'features/RoutingProjects/types'

const superclusterOptions: Supercluster.Options<GeoJsonProperties, ClusterProperties> = {
  extent: 256,
  radius: 80,
  maxZoom: 1
}

interface IClusteredMarkersProps {
  geojson: TDatasetLocationsGeojson
  stopInfoWindowOpenedCount: number
  setStopInfoWindowOpenedCount: (count: number) => void
  hideMarkers?: boolean
}

export const ClusteredMarkers = ({
  geojson,
  stopInfoWindowOpenedCount,
  setStopInfoWindowOpenedCount,
  hideMarkers
}: IClusteredMarkersProps): ReactElement | null => {
  const { clusters, getClusterExpansionZoom } = useSupercluster<IDatasetLocationProps>(geojson, superclusterOptions)

  if (hideMarkers) {
    return null
  }

  return (
    <>
      {clusters.map((feature) => {
        const [lng, lat] = feature.geometry.coordinates

        const clusterProperties = feature.properties as ClusterProperties & IDatasetLocationProps
        const isCluster: boolean = clusterProperties?.cluster

        return isCluster ? (
          <FeaturesClusterMarker
            key={feature.id}
            clusterId={feature.id as number}
            position={{ lat, lng }}
            size={clusterProperties.point_count}
            sizeAsText={String(clusterProperties.point_count_abbreviated)}
            getClusterExpansionZoom={getClusterExpansionZoom}
          />
        ) : (
          <FeatureMarker
            key={clusterProperties.id}
            stopInfoWindowOpenedCount={stopInfoWindowOpenedCount}
            setStopInfoWindowOpenedCount={setStopInfoWindowOpenedCount}
            position={{ lat, lng }}
            stops={clusterProperties.stops ?? []}
          />
        )
      })}
    </>
  )
}
